import { useState } from "react";
import { captureScreenshot } from "@/lib/bugReportUtils";

/**
 * Captures a screenshot of the current page BEFORE opening the bug report modal,
 * so the screenshot reflects what the user was viewing — not the modal itself.
 */
export function useBugReportLauncher() {
  const [open, setOpen] = useState(false);
  const [preCapture, setPreCapture] = useState<Blob | null>(null);
  const [sourcePageUrl, setSourcePageUrl] = useState("");

  const launch = async () => {
    // Record URL and capture screenshot BEFORE any UI changes
    setSourcePageUrl(window.location.href);
    try {
      const blob = await captureScreenshot();
      setPreCapture(blob);
    } catch {
      // Never block bug reporting if capture fails
    }
    setOpen(true);
  };

  const onOpenChange = (v: boolean) => {
    setOpen(v);
    if (!v) {
      setPreCapture(null);
      setSourcePageUrl("");
    }
  };

  return { open, onOpenChange, preCapture, sourcePageUrl, launch };
}
